<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15">정책 목록</div>
        <div class="setting-addel">
          <el-button size="mini" @click="addPopup"><i class="fas fa-plus"></i></el-button>
          <el-button size="mini" @click="onDeleteButton" :disabled="!checkedRows.length"><i class="fas fa-minus"></i></el-button>
        </div>
      </div>
      <div class="vertical-center-box" align="right">
        <w-header-search-button @click="toggleSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <!-- add 1210 display-exceptional -->
    <el-table-wrapper ref="ruleTable" :column-default="columnDefault" :data="syslogRuleDatas" :columns="syslogRuleColumns" highlight-current-row
    :show-search-tool="showSearchTool" :show-custom-header="true" row-class-name="c-dblclick display-exceptional"
    @row-click="onRowClick" @row-dblclick="onRowDblclick" @selection-change="onSelectionChange">
    </el-table-wrapper>
    <w-syslog-rule-setting-popup ref="addRulePopup" title="정책 추가" @load-data="loadData" @delete-selected-row="deleteSelectedRow" />
    <w-syslog-rule-setting-popup ref="updateRulePopup" title="정책 수정" :data="selectedRow" @load-data="loadData" @delete-selected-row="deleteSelectedRow" />
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import { EMPTY_TEXT } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import msgUtils from '@/utils/message';

import WHeaderSearchButton from '@/components/button/HeaderSearchButton/HeaderSearchButton';
import syslogSettingAPI from '@/api/settings/log/syslog-settings';
import WEventlevelCell from '@/components/table/EventlevelCell';
import WSyslogRuleSettingPopup from '../popup/SyslogRuleSettingPopup';

export default {
  name: 'WSyslogRuleTable',
  components: {
    WHeaderSearchButton,
    WEventlevelCell,
    WSyslogRuleSettingPopup,
  },
  data() {
    const syslogRuleColumns = [
      {
        align: 'center',
        type: 'selection',
        width: '40',
      },
      {
        prop: 'syslogRuleName',
        label: '정책 이름',
        searchable: true,
        sortable: true,
        formatter: this.getStringFormatter,
      },
      {
        prop: 'syslogRuleDesc',
        label: '설명',
        searchable: true,
        sortable: true,
        formatter: this.getStringFormatter,
      },
      {
        prop: 'filterCondition',
        label: '메시지 필터링',
        searchable: true,
        sortable: true,
        formatter: this.getStringFormatter,
      },
      {
        prop: 'exceptFilterCondition',
        label: '예외 메시지 필터링',
        searchable: true,
        sortable: true,
        formatter: this.getStringFormatter,
      },
    ];
    return {
      selectedRow: null,
      syslogRuleDatas: [],
      syslogRuleColumns,
      checkedRows: [],
      showSearchTool: false,
      columnDefault,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    /**
     * 로그 정책 목록 테이블의 데이터를 불러온다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    loadData() {
      syslogSettingAPI.getSyslogRuleList().then((response) => {
        this.syslogRuleDatas = response.data.data;
        this.$emit('target-change', this.syslogRuleDatas[0]);
        this.$nextTick(() => {
          if (!isEmpty(this.$refs.ruleTable) && !isEmpty(this.$refs.ruleTable.$children)) {
            this.$refs.ruleTable.$children[0].setCurrentRow(this.syslogRuleDatas[0]);
          }
          if (isEmpty(this.syslogRuleDatas)) {
            this.deleteSelectedRow();
            this.$emit('target-change', null);
          }
        });
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, '로그 정책 목록', false));
        throw new Error(e);
      });
    },
    getStringFormatter(row, column, value) {
      if (!isEmpty(value)) {
        return value;
      }
      return EMPTY_TEXT;
    },
    toggleSearchTool() {
      this.showSearchTool = !this.showSearchTool;
    },
    /**
     * 선택된 로그 정책을 삭제한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    onDeleteButton() {
      this.$confirm(...msgUtils.getBasicConfirmData('정책을 삭제')).then(() => {
        syslogSettingAPI.deleteSyslogRule(this.checkedRows).then((response) => {
          if (response.data.success) {
            this.$message(msgUtils.getResultMsgData(msgUtils.action.DELETE, '정책', response.data.success));
            this.loadData();
          } else {
            this.$message(msgUtils.getResultMsgData(msgUtils.action.DELETE, '정책', response.data.success));
          }
        }).catch((e) => {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.DELETE, '정책', false));
          throw new Error(e);
        });
      }).catch(() => {});
    },
    /**
     * 적용 대상 목록을 갱신한다. (Row 클릭시)
     * @author Minyeong
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    onRowClick(row) {
      this.$emit('target-change', row);
    },
    /**
     * 정책 수정 팝업을 띄운다.
     * @author Minyeong
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    onRowDblclick(row) {
      this.selectedRow = row;
      this.$refs.updateRulePopup.open();
    },
    /**
     * 정책 추가 팝업을 띄운다.
     * @author Minyeong
     */
    addPopup() {
      this.$refs.addRulePopup.$refs.slidingPopup.open();
    },
    onSelectionChange(selection) {
      this.checkedRows = selection;
    },
    /**
     * 선택된 열을 초기화한다.(추가/수정 완료 시)
     * @author Minyeong
     * @return {[type]} [description]
     */
    deleteSelectedRow() {
      this.selectedRow = null;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log/Syslog/components/SyslogRuleTable.vue